import { Fragment } from "react";
import { ChampionSkill } from "@outplayed/tooltips";
import { ReactComponent as ArrowRight } from "@ugg/shared/assets/svg/arrow-right.svg";

export function getSkillSlot(skillSlot: number | string) {
  switch (skillSlot) {
    case "Q":
    case "0":
    case 0:
      return 0;
    case "W":
    case "1":
    case 1:
      return 1;
    case "E":
    case "2":
    case 2:
      return 2;
    case "R":
    case "3":
    case 3:
      return 3;
    default:
      return -1;
  }
}

export function displaySkills(skills: string[], championId: number, ssr?: boolean) {
  const list = skills.map((skillKey, index) => {
    const skillSlot = getSkillSlot(skillKey);
    return (
      <Fragment key={index}>
        <div className="skill-wrapper">
          <ChampionSkill championId={championId} skillSlot={skillSlot} ssr={ssr} />
          <div className="label">
            <span>{skillKey.toUpperCase()}</span>
          </div>
        </div>
        {index !== 2 && <ArrowRight className="path-arrow" />}
      </Fragment>
    );
  });

  return list;
}
